import { createSetIntentType, getIntents } from '../../intent';
import { addIntentsToProps } from './props';
export const onComponentWillReceiveProps = createSetIntentType('mapProps', (decorate)=>(render)=>{
        return decorate(render);
    });
export function runPropTransforms(props) {
    const transforms = getIntents(onComponentWillReceiveProps, props);
    transforms === null || transforms === void 0 ? void 0 : transforms.forEach((callback)=>{
        addIntentsToProps(props, callback(props));
    });
}

//# sourceMappingURL=transformProps.js.map